/** @module Apparel/_MaterialFormMixin */
define([
    "dojo/_base/declare",
    "csi/comm/PostRequest",
    "csi/form/Widget",
    "csi/store/_base",
    "csi/store/Names",
    "csi/xml",
    "csi/xml/Search"
], function (declare, PostRequest, FormWidget, csiStore, Names, xml, Search) {

    return declare(FormWidget, {

        MATERIAL_SECURITY_GROUP: "MaterialSecurityGroup",
        DOCUMENT: "Document",
        MATERIAL_SECURITY_GROUPS: "MaterialSecurityGroups",
        PRODUCT_TYPE: "ProductType",

    });
});

